export default function () {
  return {
    oferte: [],
    oferteCurrentPage: 1,
    oferteLastPage: 1,
    ofertePerPage: 0,
    oferteTotal: 0,
    oferteRequestTotal: 0,
    oferteLoading: false,
    indexPage: null,
    search: '',
    datefrom: '',
    dateto: ''
  }
}
